window.addEventListener("DOMContentLoaded", function() {
  $(document).ready(function() {
    // Disable scroll
    const originalScrollTo = window.scrollTo;
    const originalScrollIntoView = Element.prototype.scrollIntoView;
    
    // Disable scroll methods
    window.scrollTo = function() {};
    Element.prototype.scrollIntoView = function() {};
    
    // Re-enable scroll methods after section re-render (or after your desired action)
    $(document).on('shopify:section:load', function() {
        // Restore the original methods
        window.scrollTo = originalScrollTo;
        Element.prototype.scrollIntoView = originalScrollIntoView;
    });

    $('.mag-pop').click(function(){
       let target = $(this).data('target');

       $.magnificPopup.open({
        items: {
          src: target
        },
        type: 'inline'
      });


    })

    $('body').on('click', (evt) => {
      const colorBg = $('.flavor-pop-container').data('text-color');
      const closeBtn = $('.mfp-close').attr('style', `color: ${colorBg} !important`);
    });

    $('body').on('click','.left-arrow, .right-arrow',function(evt){
        evt.preventDefault();
        evt.stopImmediatePropagation();

        let target = $(this).parents('.flavor-pop-container').attr('id');
        console.log(target);
        if($(this).hasClass('left-arrow')){
            if($(`[data-target="#${target}"]`).parents('.flavor').prev().length)
            $(`[data-target="#${target}"]`).parents('.flavor').prev().find('.mag-pop').click();
           else $('.flavors .flavor:last-child').find('.mag-pop').click();
        }else{
            if($(`[data-target="#${target}"]`).parents('.flavor').next().length)
            $(`[data-target="#${target}"]`).parents('.flavor').next().find('.mag-pop').click();
        else $('.flavors .flavor:first-child').find('.mag-pop').click();
        }
    });

    
    const atcStaticText = "Add to cart";
    function updateAddToCartButton() {
      var step2Complete = $('.cores-club').hasClass('complete');
      var step2Open = true;
      var totalSelected = parseInt($('.selected-pack:eq(0)').text(), 10);
      var maxPackItems = parseInt($('.max-pack:eq(0)').text(), 10);
      var buttonText;

      const atcButtonSelector = ".add-to-cart";
      
      if (step2Complete) {
        // buttonText = 'Buy Now';
        buttonText = atcStaticText;
        $(atcButtonSelector).removeClass('disabled outline').addClass('solid').removeAttr('disabled');
      } else {
        // buttonText = totalSelected + '/' + maxPackItems + ' selected';
        buttonText = atcStaticText;
        $(atcButtonSelector).removeClass('disabled outline').addClass('solid').attr('disabled', true);
      }



      $('.add-to-cart span:first-child').text(buttonText);

      const enableATCButton = (button, is_enabled = false) => {
        if (is_enabled) {
          button.removeAttr('disabled').removeClass('disabled outline').addClass('solid');
        } else {
          button.attr('disabled', true).addClass('disabled outline').removeClass('solid');
        }
      }

      const atcButtons = [$('.add-to-cart'), $('#stickyButton')];
      atcButtons.forEach((_button) => {
        if (step2Complete) {
          enableATCButton(_button, true);
        } else {
          enableATCButton(_button, false);
        }
      });

      const getPrice = $('.total-price').text();
    }


     const observePriceChange = (selectorDetect, selectorReplace) => {
      var targetSpan = $(selectorDetect);
      var observer = new MutationObserver(function(mutations) {
        $(selectorReplace).text(targetSpan.text());
      });
    
      var config = { childList: true, subtree: true };
      observer.observe(targetSpan[0], config);
    };

    observePriceChange('.total-price', '.total-price-sticky-clone');

    
    $('.quantity-selector').hide();

    var maxPackItems = 3;
    let totalSelectedFlavorCores = 0;
    // function updateProgressBar() {
    //   var totalSelected = 0;
      
    //   if (totalSelected >= maxPackItems) {
    //     $('.quantity-selector .plus-btn').each(function () {
    //       var plusBtn = $(this).closest('.quantity-selector .plus-btn');
    //       // console.log("PLUS BTN", plusBtn);
    //       plusBtn.prop('disabled', true);
    //     });
    //   }

    //   let _totalSelected = 0;
    //   $('.quantity-selector input').each(function() {
    //     _totalSelected += parseInt($(this).val());
    //     var valueCounter = $(this).siblings('.fum-quantity-counter');

    //     if (_totalSelected <= maxPackItems) {
    //       valueCounter.text($(this).val());
    //     }
    //   });
    //   totalSelected = _totalSelected;

    //   if (totalSelected >= maxPackItems) {
    //     let overage = totalSelected - maxPackItems;
    //     $('.quantity-selector input').each(function() {
    //       if (overage > 0) {
    //         let currentValue = parseInt($(this).val(), 10);
    //         if (currentValue > 0) {
    //           let reduction = Math.min(currentValue, overage);
    //           $(this).val(currentValue - reduction);
    //           overage -= reduction;
    //           if ($(this).val() === "0") {
    //             $(this).closest('.quantity-selector').hide();
    //             $(this).closest('.flavor').find('.flav-select').show();
    //           }
    //         }
    //       }
    //     });
    //   }

    //   totalSelected = 0;
    //   $('.quantity-selector input').each(function() {
    //     totalSelected += parseInt($(this).val(), 10);
    //   });

    //   $('.selected-pack').text(totalSelected);
    //   var percentage = (totalSelected / maxPackItems) * 100;
    //   $('.progress').css('width', percentage + '%');
    //   totalSelectedFlavorCores = totalSelected;

    //   if (totalSelected >= maxPackItems) {        
    //     $('.cores-club').addClass('complete');
    //     $('.quantity-selector input').each(function() {
    //       if ($(this).val() == 0) {
    //         $(this).prop('disabled', true);
    //         $(this).siblings('.plus-btn').prop('disabled', true);
    //       }
    //     });

    //     $('.plus-btn').prop('disabled', true);
    //     $('.flav-select').prop('disabled', true);
    //   } else {
    //     $('.cores-club').removeClass('complete');
    //     $('.quantity-selector input').prop('disabled', false);
    //     $('.plus-btn').prop('disabled', false);
    //     $('.flav-select').prop('disabled', false);

    //     $('.quantity-selector input').each(function() {
    //       var currentValue = parseInt($(this).val(), 10);
    //       if (currentValue >= maxPackItems) {
    //         $(this).siblings('.plus-btn').prop('disabled', true);
    //       } else {
    //         $(this).siblings('.plus-btn').prop('disabled', false);
    //       }
    //     });
    //   }

    //   updateAddToCartButton();
    // }

    function updateProgressBar() {
      var totalSelected = 0;

      $('.quantity-selector input').each(function() {
          totalSelected += parseInt($(this).val(), 10);
          // var valueCounter = $(this).siblings('.fum-quantity-counter');
          // valueCounter.text($(this).val());
      });


      totalSelected = 0;
      $('.quantity-selector input').each(function() {
          totalSelected += parseInt($(this).val(), 10);
      });

      // $('.selected-pack').text(Math.min(totalSelected, maxPackItems));
      $('.selected-pack').text(Math.min(totalSelected, maxPackItems));
      totalSelectedFlavorCores = totalSelected;
      var percentage = (totalSelected / maxPackItems) * 100;
      $('.progress').css('width', percentage + '%');

      if (totalSelected >= maxPackItems) {
          $('.cores-club').addClass('complete');
          $('.quantity-selector input').each(function() {
              if ($(this).val() == 0) {
                  $(this).prop('disabled', true);
                  $(this).siblings('.plus-btn').prop('disabled', true);
              }
          });

          // $('.plus-btn').prop('disabled', true);
          // $('.flav-select').prop('disabled', true);
      } else {
          $('.cores-club').removeClass('complete');
          $('.quantity-selector input').prop('disabled', false);
          $('.plus-btn').prop('disabled', false);
          $('.flav-select').prop('disabled', false);

          $('.quantity-selector input').each(function() {
              var currentValue = parseInt($(this).val(), 10);
              // var valueCounter = $(this).siblings('.fum-quantity-counter');
              if (currentValue >= maxPackItems) {
                  $(this).siblings('.plus-btn').prop('disabled', true);
              } else {
                  $(this).siblings('.plus-btn').prop('disabled', false);
              }
              // currentValue = parseInt($(this).val(), 10);
              // valueCounter.text($(this).val())
              // console.log("Update Quantity", currentValue);
          });
      }

      let _totalSelected = 0;
      $('.quantity-selector input').each(function() {
        _totalSelected += parseInt($(this).val());
        var valueCounter = $(this).siblings('.fum-quantity-counter');
        
        valueCounter.text($(this).val());
      });
      totalSelectedFlavorCores = _totalSelected;
      totalSelected = _totalSelected;
      console.log("_totalSelected", {
        _totalSelected,
        totalSelected,
        totalSelectedFlavorCores
      })

      setTimeout(() => {
        let overage = totalSelected - maxPackItems;
        if (totalSelected > maxPackItems) {
            $('.quantity-selector input').each(function() {
                if (overage > 0) {
                    let currentValue = parseInt($(this).val(), 10);
                    if (currentValue > 0) {
                        let reduction = Math.min(currentValue, overage);
                        let newValue = currentValue - reduction;
                        console.log("OVERAGE REDUCTION", {
                          overage,
                          reduction,
                          currentValue
                        });
                        $(this).val(newValue);
                        overage -= reduction;
                        if (newValue === 0) {
                            $(this).closest('.quantity-selector').hide();
                            $(this).closest('.flavor').find('.flav-select').show();
                        }

                        console.log("OVERAGE INNER", {
                          overage,
                          reduction,
                          newValue,
                          currentValue, 
                          totalSelected,
                          maxPackItems
                        })
                    }
                }
            });
        }
      }, 300);
      updateAddToCartButton();
    }
    
    // Step 1: Select all elements with the class "pack-option"
    const getAllPackOptions = document.querySelectorAll(".pack-option");

    // Step 2: Initialize an empty array to store the 'data-pack' attribute values from each element
    let dataPackCountFromOptions = [];

    // Step 3: Loop through each selected element (pack-option) and extract the value of the 'data-pack' attribute
    getAllPackOptions.forEach((item, key) => {
      // Get the value of the 'data-pack' attribute for the current element
      const _packCount = parseInt(item.getAttribute("data-pack"));
      // Step 4: Add the extracted 'data-pack' value to the array (dataPackCountFromOptions)
      if (!dataPackCountFromOptions.includes(_packCount)) {
        dataPackCountFromOptions.push(_packCount);
      }
    })

    function getNextHigherValue(arr, currentValue) {
      // Sort the array in ascending order
      arr.sort((a, b) => a - b);
      
      // Find the next higher value
      const nextValue = arr.find(value => value >= currentValue);
      
      return nextValue;
    }

    const autoSelectNextPack = () => {
      // const _totalSelected = parseInt($('.selected-pack:eq(0)').text(), 10);
      const _totalSelected = parseInt(totalSelectedFlavorCores, 10);

      console.log("autoSelectNextPack:", _totalSelected);
      
      // Step 5: Use Math.max() to find the highest value in the 'dataPackCountFromOptions' array
      // Since the array contains string values, spread the array and Math.max() will find the largest number
      const getHighestDataPackCountFromOptions = Math.max(...dataPackCountFromOptions);
      // console.log("dataPackCountFromOptions: ", dataPackCountFromOptions);
      
      // Step 6: Check if the total selected packs (_totalSelected) is greater than or equal to the maximum allowed (maxPackItems)
      // AND if it is less than the highest 'data-pack' value from the options.
      let nextHigherPack;
      let _packButtonRef;
      if (_totalSelected >= maxPackItems && _totalSelected < getHighestDataPackCountFromOptions) {
        
        // Step 7: If the conditions are met, find the next higher 'data-pack' value that is greater than or equal to _totalSelected
        nextHigherPack = getNextHigherValue(dataPackCountFromOptions, _totalSelected);

        const packOptionButton = $(`.pack-option[data-pack="${nextHigherPack}"]`);
        _packButtonRef = packOptionButton;

        selectAllFlavors = false;
        packOptionButton.click()
        selectAllFlavors = true;
      }

      console.log("autoSelectNextPack:", {
        totalSelected: _totalSelected,
        ifGreater: _totalSelected >= maxPackItems && _totalSelected < getHighestDataPackCountFromOptions,
        nextHigherPack,
        dataPackCountFromOptions,
        _packButtonRef
      })
    }

    const flavorActionButtonFunc = (d) => {
      $(d).hide();
      var quantitySelector = $(d).siblings('.quantity-selector');
      quantitySelector.show();
      quantitySelector.find('input').val(1).change();
      updateProgressBar();
    }

    const step2WrapperSelector = '.cores-club .fum-journeypdp-variant-selectable img';
    const step2ButtonSelector = '.flav-select';
    $(step2ButtonSelector).click(function() {
      flavorActionButtonFunc(this);
      autoSelectNextPack();
      updateProgressBar();
    });
    $(step2WrapperSelector).click(function () {
      const findButton = $(this).siblings(step2ButtonSelector);
      findButton.click();
    });

    $('.pack-option').click(function() {
      $('.pack-option').removeClass('selected');
      $(this).addClass('selected');
      maxPackItems = parseInt($(this).data('pack'), 10);
      $('.max-pack').text(maxPackItems);
      $(`.product-form__input:eq(0) input[value="${$(this).data('pack-name')}"]`).click();

      const selectAllCores = $(this).data('select-all-cores');
      if (selectAllCores) {
        const getAllCores = $('#fum-flavor-cores-step-2').children();

        getAllCores.each((index, item) => {
          const findButton = $(item).find('.select-button');
          findButton.click();
        });
      }

      updateProgressBar();
    });

    $('.minus-btn').click(function() {
      // var quantityInput = $(this).siblings('input');
      // var currentValue = parseInt(quantityInput.val());

      // if (currentValue > 1) {
      //   quantityInput.val(currentValue - 1);
      // } else {
      //   quantityInput.val(0);
      //   $(this).closest('.quantity-selector').hide();
      //   $(this).closest('.flavor').find('.flav-select').show();
      // }
      // updateProgressBar();
      var quantityInput = $(this).siblings('input');
      var currentValue = parseInt(quantityInput.val());

      if (currentValue > 1) {
          quantityInput.val(currentValue - 1);
      } else {
          quantityInput.val(0);
          $(this).closest('.quantity-selector').hide();
          $(this).closest('.flavor').find('.flav-select').show();
      }

      autoSelectNextPack();          
      updateProgressBar();
    });

    const countSelected = () => {
      var totalSelected = 0;

      $('.quantity-selector input').each(function() {
        // totalSelected += parseInt($(this).val(), 10);
        var quantity = parseInt($(this).val());
        if (quantity <= 0 || isNaN(quantity)) {
            $(this).val(0);
            $(this).closest('.quantity-selector').hide();
            $(this).closest('.flavor').find('.flav-select').show();
        } else if (quantity < maxPackItems) {
            $(this).val(quantity);
        }

        updateProgressBar();
        autoSelectNextPack();
      });

      return totalSelected;
    }

    $('.plus-btn').click(function() {
      // var quantityInput = $(this).siblings('input');
      // var currentValue = parseInt(quantityInput.val(), 10);

      // var totalSelected = 0;

      // if (currentValue < maxPackItems && totalSelected <= maxPackItems) {
      //   quantityInput.val(currentValue + 1);
      // }

      // updateProgressBar();
      var quantityInput = $(this).siblings('input');
      var currentValue = parseInt(quantityInput.val());
      const _totalSelected = parseInt(totalSelectedFlavorCores, 10);
      highestAvailablePackCount = Math.max(...dataPackCountFromOptions);

      
      if (currentValue < highestAvailablePackCount && _totalSelected < highestAvailablePackCount) {
          quantityInput.val(currentValue + 1); 

          console.log("plusBtn", {
            quantityInput,
            currentValue,
            _totalSelected
          })
      }

      updateProgressBar();
      autoSelectNextPack();
    });

    $('.quantity-selector input').on('input', function() {
      var quantity = parseInt($(this).val());
      if (quantity <= 0 || isNaN(quantity)) {
        $(this).val(0);
        $(this).closest('.quantity-selector').hide();
        $(this).closest('.flavor').find('.flav-select').show();
      } else if (quantity < maxPackItems) {
        $(this).val(quantity);
      }
      updateProgressBar();
    });

    $('.add-to-cart').click(function(e) {
      e.preventDefault();

      const form = $('product-form.product-form form');

        form.find('input[name^="properties"]').remove();

      let flavorIndex = 1;
      let childVariantLines = {};
      $('.flavor').each(function(index) {
        const quantity = parseInt($(this).find('input[type="number"]').val(), 10);
        const flavorName = $(this).data('name');
        const flavorSku = $(this).data('sku');
        const flavorId = $(this).data('variant-id');

        if (quantity > 0) {
          const inputName = `properties[Flavor ${flavorIndex}]`;
          const inputValue = `${quantity}x ${flavorName}`;

          const skuInputName = `properties[_SKU ${flavorSku}]`;
          const skuInputValue = `${quantity}x ${flavorName}`;

         const qtyInputName = `properties[_Quantity${flavorIndex}]`;
          const qtyInputValue = `${quantity}`;
          
          const hiddenInput = $('<input>', {
            type: 'hidden',
            name: inputName,
            value: inputValue,
            form: form.attr('id')
          });

          form.append(hiddenInput);

          const hiddenInputSku = $('<input>', {
            type: 'hidden',
            name: skuInputName,
            value: skuInputValue,
            form: form.attr('id')
          });

          form.append(hiddenInputSku);


              const hiddenInputQty = $('<input>', {
                        type: 'hidden',
                        name: qtyInputName,
                        value: qtyInputValue,
                        form: form.attr('id')
                    });
                    
                    form.append(hiddenInputQty);


          
          flavorIndex += 1;

          if (childVariantLines[flavorId]) {
            childVariantLines[flavorId] += quantity;
          } else {
            childVariantLines[flavorId] = quantity;
          }
        }
      });

      if (Object.keys(childVariantLines).length > 0) {
        const childLinesInput = $('<input>', {
          type: 'hidden',
          form: form.attr('id'),
          name: 'properties[_childLines]'
        }).val(JSON.stringify(childVariantLines));

        form.append(childLinesInput);
      }

      var step2Complete = $('.cores-club').hasClass('complete');

      if (step2Complete) {
        form[0].dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    });

    $('.step-content.fum-journeypdp-step-item').attr('aria-expanded', 'true').removeAttr('animating');
    
    updateAddToCartButton();


  });
});

window.addEventListener("scroll", function() {
  var button = document.getElementById("stickyButton");
  var tabContainer = document.getElementById("fum-flavor-cores-step-2");
  var mobileButton = document.getElementById("mobileStickyButtonWrapper");
  
  var buttonContainer = button.parentElement;
  var buttonPosition = buttonContainer.getBoundingClientRect().top + window.pageYOffset;
  var tabContainer = tabContainer.parentElement;
  var tabPosition = tabContainer.getBoundingClientRect().top + window.pageYOffset;
  var windowHeight = window.innerHeight;
  
  if (window.innerWidth <= 749) {
    if (window.pageYOffset + windowHeight >= buttonPosition) {
      mobileButton.style.display = "block";
    }
    if (window.pageYOffset + windowHeight >= tabPosition) {
   
    // buttonContainer.style.display = "none"
    mobileButton.style.display="block"
   
  }
    else {
      mobileButton.style.display = "none";
    }
  }
});
